import { Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-form-checkbox',
  styleUrls: ['form-checkbox.component.scss'],
  template: `
    <mat-checkbox
      [ariaRoleDescription]="'checkbox'"
      [ariaChecked]="formControl.value"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [required]="props.required"
      (change)="change()"
      ><span tabindex="0" [innerHTML]="props.label"></span
    ></mat-checkbox>
    @if (
      formControl.hasError('required') && !formControl.hasError('regRequired')
    ) {
      <mat-error>This field is required</mat-error>
    }
    @if (formControl.hasError('regRequired')) {
      <mat-error
        >This field is needed for suitability review. You can opt out below if
        the applicant refuses to provide the information.</mat-error
      >
    }
  `,
  imports: [
    FormlyModule,
    MatInputModule,
    MatCheckboxModule,
    ReactiveFormsModule,
  ],
})
export class FormlyCheckboxComponent extends FieldType {
  change() {}
}
